(function () {
  'use strict';

  if (!window.themeCartDrawer || !window.themeCartDrawer.enabled) return;

  var config = window.themeCartDrawer;
  var drawer = document.getElementById('cart-drawer');
  if (!drawer) return;

  var sectionId = 'cart-drawer';
  var recommendationsSectionId = 'cart-drawer-recommendations';
  var promoTimer = null;
  var refreshController = null;
  var cartDirty = false;
  var layoutTimer = null;

  function getRoot() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  function openDrawer() {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-drawer-open');
    initPromoCountdown();
    // Only re-init wallets when drawer becomes visible (cheap if already painted)
    schedulePaymentLayout(80);
    reinitSwymWishlist();
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-drawer-open');
  }

  function setLoading(loading) {
    drawer.classList.toggle('is-loading', !!loading);
    drawer.setAttribute('aria-busy', loading ? 'true' : 'false');
    var loader = drawer.querySelector('.cart-drawer__loader');
    if (loader) loader.setAttribute('aria-hidden', loading ? 'false' : 'true');
  }

  function updateBadge(count) {
    document.querySelectorAll('.tt-badge-cart').forEach(function (el) {
      el.textContent = count;
      if (count === 0) el.classList.add('hide');
      else el.classList.remove('hide');
    });
  }

  /**
   * Full section re-render is expensive (cross-sell + wallets).
   * Only call after cart changes — not on every cart-icon click.
   */
  function refreshDrawer(callback) {
    if (refreshController) {
      try {
        refreshController.abort();
      } catch (e) {}
    }
    refreshController = typeof AbortController !== 'undefined' ? new AbortController() : null;

    setLoading(true);
    var opts = { credentials: 'same-origin' };
    if (refreshController) opts.signal = refreshController.signal;

    fetch(getRoot() + '?sections=' + sectionId, opts)
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        var html = data[sectionId];
        if (!html) return;
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newDrawer = doc.getElementById('cart-drawer');
        if (!newDrawer) return;
        drawer.innerHTML = newDrawer.innerHTML;
        cartDirty = false;
        bindEvents();
        initPromoCountdown();
        initPaymentButtons();
        loadRecommendations();
        initReviewsCarousel();
        reinitSwymWishlist();
        if (typeof callback === 'function') callback();
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
      })
      .finally(function () {
        setLoading(false);
      });
  }

  function schedulePaymentLayout(delay) {
    if (layoutTimer) clearTimeout(layoutTimer);
    layoutTimer = setTimeout(function () {
      layoutTimer = null;
      ensureExpressFullWidth();
    }, delay || 0);
  }

  function initPaymentButtons() {
    if (window.Shopify && Shopify.PaymentButton && typeof Shopify.PaymentButton.init === 'function') {
      Shopify.PaymentButton.init();
    }
    schedulePaymentLayout(120);
  }

  /**
   * Shopify stacks wallets vertically when the container is too narrow.
   * Keep #dynamic-checkout-cart at full drawer width so the component
   * can use its built-in horizontal row layout.
   * @see https://shopify.dev/docs/storefronts/themes/pricing-payments/accelerated-checkout
   */
  function ensureExpressFullWidth() {
    var express = drawer.querySelector('.cart-drawer__express');
    if (!express) return;

    express.style.setProperty('width', '100%', 'important');
    express.style.setProperty('max-width', '100%', 'important');

    var content = express.querySelector('#dynamic-checkout-cart, .dynamic-checkout__content');
    if (content) {
      content.style.setProperty('width', '100%', 'important');
      content.style.setProperty('max-width', '100%', 'important');
      content.style.setProperty('flex', 'none', 'important');
      content.style.removeProperty('max-width');
      content.style.setProperty('max-width', '100%', 'important');
    }

    var wallet = express.querySelector('shopify-accelerated-checkout-cart');
    if (wallet) {
      wallet.style.setProperty('width', '100%', 'important');
      wallet.style.setProperty('max-width', '100%', 'important');
      wallet.style.setProperty('--shopify-accelerated-checkout-button-inline-size', '170px');
      wallet.style.setProperty('--shopify-accelerated-checkout-button-block-size', '44px');
      wallet.style.setProperty('--shopify-accelerated-checkout-inline-alignment', 'space-between');
    }
  }

  /**
   * Fetch Search & Discovery recommendations (complementary / related)
   * @see https://shopify.dev/docs/storefronts/themes/product-merchandising/recommendations
   */
  function loadRecommendations() {
    var host = drawer.querySelector('[data-recommendations-host]');
    if (!host) return;

    var intent = host.getAttribute('data-intent');
    var limit = parseInt(host.getAttribute('data-limit'), 10) || 4;
    var productIds = (host.getAttribute('data-product-ids') || '')
      .split(',')
      .filter(Boolean);
    var cartHandles = (host.getAttribute('data-cart-handles') || '')
      .split(',')
      .filter(Boolean);
    var grid = host.querySelector('[data-recommendations-grid]');
    var shell = host.querySelector('.cart-drawer__cross-sell');

    if (!grid || !productIds.length || !intent) {
      if (host) host.remove();
      return;
    }

    if (shell) shell.classList.add('cart-drawer__cross-sell--loading');

    var collected = [];
    var seenHandles = {};

    function fetchForProduct(index) {
      if (collected.length >= limit || index >= productIds.length) {
        finish();
        return;
      }

      var url =
        getRoot() +
        'recommendations/products?section_id=' +
        recommendationsSectionId +
        '&product_id=' +
        productIds[index] +
        '&intent=' +
        intent +
        '&limit=' +
        limit;

      fetch(url, { credentials: 'same-origin' })
        .then(function (res) {
          return res.text();
        })
        .then(function (html) {
          if (html && html.trim()) {
            var tmp = document.createElement('div');
            tmp.innerHTML = html;
            tmp.querySelectorAll('.cart-drawer__cross-sell-card').forEach(function (card) {
              if (collected.length >= limit) return;
              var handle = card.getAttribute('data-product-handle');
              if (!handle || seenHandles[handle]) return;
              if (cartHandles.indexOf(handle) !== -1) return;
              seenHandles[handle] = true;
              collected.push(card.cloneNode(true));
            });
          }
          fetchForProduct(index + 1);
        })
        .catch(function () {
          fetchForProduct(index + 1);
        });
    }

    function finish() {
      grid.innerHTML = '';
      if (!collected.length) {
        // Hide entire upsell block (heading + grid) when nothing left to show
        host.remove();
        return;
      }
      collected.forEach(function (card) {
        grid.appendChild(card);
      });
      if (shell) shell.classList.remove('cart-drawer__cross-sell--loading');
      bindEvents();
    }

    fetchForProduct(0);
  }

  function initReviewsCarousel() {
    var root = drawer.querySelector('[data-cart-drawer-reviews]');
    if (!root || root.getAttribute('data-reviews-ready') === 'true') return;

    var track = root.querySelector('[data-reviews-track]');
    var slides = root.querySelectorAll('[data-review-slide]');
    var prevBtn = root.querySelector('[data-reviews-prev]');
    var nextBtn = root.querySelector('[data-reviews-next]');
    if (!track || slides.length < 2) return;

    var index = 0;

    function goTo(nextIndex) {
      index = (nextIndex + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + index * 100 + '%)';
      slides.forEach(function (slide, i) {
        var active = i === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        goTo(index - 1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        goTo(index + 1);
      });
    }

    root.setAttribute('data-reviews-ready', 'true');
    goTo(0);
  }

  function changeLine(line, quantity) {
    setLoading(true);
    cartDirty = true;
    fetch(getRoot() + 'cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity }),
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        if (typeof addToCartHandler !== 'undefined') {
          addToCartHandler.updateGeneralInfo(cart);
        }
        updateBadge(cart.item_count);
        refreshDrawer();
        document.body.dispatchEvent(new CustomEvent('refreshCurrency'));
      })
      .catch(function () {
        setLoading(false);
      });
  }

  function addVariant(variantId) {
    setLoading(true);
    cartDirty = true;
    fetch(getRoot() + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    })
      .then(function (res) {
        return res.json();
      })
      .then(function () {
        // One section refresh is enough — skip extra /cart.js round-trip
        return fetch(getRoot() + 'cart.js', { credentials: 'same-origin' });
      })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        if (typeof addToCartHandler !== 'undefined') {
          addToCartHandler.updateGeneralInfo(cart);
        }
        updateBadge(cart.item_count);
        if (!drawer.classList.contains('is-open')) openDrawer();
        refreshDrawer();
        document.body.dispatchEvent(new CustomEvent('refreshCurrency'));
      })
      .catch(function () {
        setLoading(false);
      });
  }

  function initPromoCountdown() {
    if (promoTimer) {
      clearInterval(promoTimer);
      promoTimer = null;
    }
    var promo = drawer.querySelector('.cart-drawer__promo');
    if (!promo) return;
    var endStr = promo.getAttribute('data-promo-end');
    if (!endStr) return;
    var end = new Date(endStr.replace(' ', 'T')).getTime();
    if (isNaN(end)) return;
    var timerEl = promo.querySelector('.cart-drawer__promo-timer');
    if (!timerEl) return;
    var expiredText = promo.getAttribute('data-promo-expired') || 'Code expired';

    function pad(n) {
      return n < 10 ? '0' + n : String(n);
    }

    function formatRemaining(diff) {
      var totalSeconds = Math.floor(diff / 1000);
      var totalMinutes = Math.floor(totalSeconds / 60);
      var secs = totalSeconds % 60;

      if (totalMinutes >= 60) {
        var hours = Math.floor(totalMinutes / 60);
        var mins = totalMinutes % 60;
        return pad(hours) + ':' + pad(mins) + ':' + pad(secs);
      }

      return pad(totalMinutes) + ':' + pad(secs);
    }

    function tick() {
      var diff = end - Date.now();
      if (diff <= 0) {
        timerEl.textContent = expiredText;
        promo.classList.add('cart-drawer__promo--expired');
        clearInterval(promoTimer);
        promoTimer = null;
        return;
      }
      promo.classList.remove('cart-drawer__promo--expired');
      timerEl.textContent = formatRemaining(diff);
    }
    tick();
    promoTimer = setInterval(tick, 1000);
  }

  function bindEvents() {
    drawer.querySelectorAll('[data-cart-drawer-close]').forEach(function (el) {
      el.addEventListener('click', closeDrawer);
    });

    drawer.querySelectorAll('[data-cart-drawer-remove]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        changeLine(parseInt(btn.getAttribute('data-line'), 10), 0);
      });
    });

    drawer.querySelectorAll('[data-cart-drawer-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var line = parseInt(btn.getAttribute('data-line'), 10);
        var input = drawer.querySelector(
          '.cart-drawer__qty-input[data-line="' + line + '"]'
        );
        if (!input) return;
        var current = parseInt(input.value, 10) || 0;
        var delta = parseInt(btn.getAttribute('data-cart-drawer-qty'), 10);
        var next = Math.max(0, current + delta);
        changeLine(line, next);
      });
    });

    drawer.querySelectorAll('[data-cart-drawer-add]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        addVariant(btn.getAttribute('data-variant-id'));
      });
    });

    bindWishlistLoading();
  }

  /**
   * Swym only binds wishlist buttons on first page load.
   * After Section Rendering replaces drawer HTML, re-init buttons.
   * @see https://developers.getswym.com/docs/swym-powered-buttons
   */
  function reinitSwymWishlist() {
    function init(swat) {
      if (!swat || typeof swat.initializeActionButtons !== 'function') return;
      setTimeout(function () {
        swat.initializeActionButtons('#cart-drawer');
      }, 50);
    }

    if (window._swat) {
      init(window._swat);
      return;
    }

    window.SwymCallbacks = window.SwymCallbacks || [];
    window.SwymCallbacks.push(init);
  }

  function bindWishlistLoading() {
    drawer.querySelectorAll('.cart-drawer__wishlist').forEach(function (btn) {
      if (btn.getAttribute('data-wishlist-loading-bound') === 'true') return;
      btn.setAttribute('data-wishlist-loading-bound', 'true');

      btn.addEventListener('click', function () {
        if (btn.classList.contains('is-loading')) return;

        var finished = false;

        // Freeze other hearts so Swym's temporary .disabled/.swym-adding
        // state does not paint every heart red while this request runs
        drawer.classList.add('cart-drawer--wishlist-pending');
        drawer.querySelectorAll('.cart-drawer__wishlist').forEach(function (other) {
          if (other === btn) return;
          if (!other.classList.contains('swym-added')) {
            other.classList.add('cart-drawer__wishlist--keep-empty');
          }
        });

        function clearWishlistPending() {
          drawer.classList.remove('cart-drawer--wishlist-pending');
          drawer.querySelectorAll('.cart-drawer__wishlist--keep-empty').forEach(function (el) {
            el.classList.remove('cart-drawer__wishlist--keep-empty');
          });
        }

        function done() {
          if (finished) return;
          finished = true;
          btn.classList.remove('is-loading');
          setLoading(false);
          clearWishlistPending();
          document.removeEventListener('swym:added-to-wishlist', done);
          document.removeEventListener('swym:removed-from-wishlist', done);
          document.removeEventListener('swym:layer-on-show', done);
          reinitSwymWishlist();
        }

        btn.classList.add('is-loading');
        setLoading(true);

        document.addEventListener('swym:added-to-wishlist', done);
        document.addEventListener('swym:removed-from-wishlist', done);
        document.addEventListener('swym:layer-on-show', done);
        setTimeout(done, 5000);

        setTimeout(function () {
          if (finished) return;
          if (btn.classList.contains('swym-added') || btn.classList.contains('swym-loaded')) return;
          addToWishlistViaSwym(btn, done);
        }, 400);
      });
    });
  }

  function addToWishlistViaSwym(btn, done) {
    function run(swat) {
      if (!swat || typeof swat.addToWishList !== 'function') {
        done();
        return;
      }
      var productId = parseInt(btn.getAttribute('data-product-id'), 10);
      var variantId = parseInt(btn.getAttribute('data-variant-id'), 10);
      var productUrl = btn.getAttribute('data-product-url');
      if (!productId || !variantId || !productUrl) {
        done();
        return;
      }
      swat.addToWishList(
        { empi: productId, epi: variantId, du: productUrl },
        function () {
          done();
        },
        function () {
          done();
        }
      );
    }

    if (window._swat) {
      run(window._swat);
    } else {
      window.SwymCallbacks = window.SwymCallbacks || [];
      window.SwymCallbacks.push(run);
    }
  }

  function interceptCartIcon() {
    document.querySelectorAll('.tt-cart.cart-drawer-mode .tt-dropdown-toggle').forEach(function (btn) {
      btn.addEventListener(
        'click',
        function (e) {
          e.preventDefault();
          e.stopImmediatePropagation();
          // Instant open — no network. Refresh only if cart changed since last render.
          openDrawer();
          if (cartDirty) refreshDrawer();
          else loadRecommendations();
        },
        true
      );
    });
  }

  function hookAddToCart() {
    if (typeof Shopify === 'undefined') return;
    var originalOnCartUpdate = Shopify.onCartUpdate;
    Shopify.onCartUpdate = function (cart) {
      if (typeof addToCartHandler !== 'undefined') {
        addToCartHandler.updateGeneralInfo(cart);
      }
      updateBadge(cart.item_count);
      cartDirty = true;

      if (!config.hidePopup && typeof originalOnCartUpdate === 'function') {
        originalOnCartUpdate(cart);
        return;
      }

      // Open immediately with current markup, then refresh in background
      openDrawer();
      refreshDrawer();

      if (typeof quick_view_loader !== 'undefined') {
        quick_view_loader.added();
      }
      document.body.dispatchEvent(new CustomEvent('refreshCurrency'));
    };
  }

  function watchAfsDrawerHook() {
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.attributeName === 'class' && document.body.classList.contains('js-cart-open')) {
          document.body.classList.remove('js-cart-open');
          openDrawer();
          if (cartDirty) refreshDrawer();
          else loadRecommendations();
        }
      });
    });
    observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
      closeDrawer();
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    bindEvents();
    interceptCartIcon();
    hookAddToCart();
    watchAfsDrawerHook();
    initPromoCountdown();
    initReviewsCarousel();
    reinitSwymWishlist();
  });
})();
